import React from 'react';
import { Hero } from '../components/home/Hero';
import { WhatIsDTech } from '../components/home/WhatIsDTech';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { AvailabilityDelivery } from '../components/home/AvailabilityDelivery';
import { WhyDTechUnified } from '../components/home/WhyDTechUnified';
import { Applications } from '../components/home/Applications';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-765">
      <PromoPopup onRequestQuote={() => onRequestQuote()} data-id="element-766" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-767" />
      <WhatIsDTech data-id="element-768" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-769" />
      <AvailabilityDelivery onRequestQuote={() => onRequestQuote()} data-id="element-770" />
      <WhyDTechUnified data-id="element-771" />
      <Applications data-id="element-772" />
    </main>;
}